import React, { useCallback } from 'react';
import { Redirect, RouteComponentProps } from 'react-router';
import { LanguageCode } from '@tink/config/src/markets';
import { LanguageCodeUrlMap } from '../PrivacyPolicy/PrivacyPolicy';
import { LegalTemplate } from '../organisms/LegalTemplate/LegalTemplate';
import { isChromeless } from '../atoms/isChromeless';

export const termsAndConditionsHTML: LanguageCodeUrlMap = {
  [LanguageCode.cs]:
    'https://cdn.tink.se/legal/terms-and-conditions/en_CZ/terms-and-conditions-en_CZ-230227-v2.html',
  [LanguageCode.et]:
    'https://cdn.tink.se/legal/terms-and-conditions/et_EE/terms-and-conditions-et_EE-210331.html',
  [LanguageCode.en]:
    'https://cdn.tink.se/legal/terms-and-conditions/en_UK/terms-and-conditions-en_UK-220906.html',
  [LanguageCode.es]:
    'https://cdn.tink.se/legal/terms-and-conditions/es_ES/terms-and-conditions-es_ES-210608.html',
  [LanguageCode.fi]:
    'https://cdn.tink.se/legal/terms-and-conditions/fi_FI/terms-and-conditions-fi_FI-210608.html',
  [LanguageCode.it]:
    'https://cdn.tink.se/legal/terms-and-conditions/it_IT/terms-and-conditions-it_IT-210531.html',
  [LanguageCode.lt]:
    'https://cdn.tink.se/legal/terms-and-conditions/lt_LT/terms-and-conditions-lt_LT-210331.html',
  [LanguageCode.lv]:
    'https://cdn.tink.se/legal/terms-and-conditions/lv_LV/terms-and-conditions-lv_LV-210331.html',
  [LanguageCode.nl]:
    'https://cdn.tink.se/legal/terms-and-conditions/nl_NL/terms-and-conditions-nl_NL-210608.html',
  [LanguageCode.pt]:
    'https://cdn.tink.se/legal/terms-and-conditions/pt_PT/terms-and-conditions-pt_PT-210531-v2.html',
  [LanguageCode.pl]:
    'https://cdn.tink.se/legal/terms-and-conditions/pl_PL/terms-and-conditions-pl_PL-210602.html',
  [LanguageCode.sv]:
    'https://cdn.tink.se/legal/terms-and-conditions/terms-and-conditions-sv_SE-220521-v3.html',
  [LanguageCode.de]:
    'https://cdn.tink.se/legal/terms-and-conditions/de_DE/terms-and-conditions-de_DE-220117.html',
  [LanguageCode.fr]:
    'https://cdn.tink.se/legal/terms-and-conditions/fr_FR/terms-and-conditions-fr_FR-210531.html',
  [LanguageCode.no]:
    'https://cdn.tink.se/legal/terms-and-conditions/no_NO/terms-and-conditions-no_NO-210610-v2.html',
  [LanguageCode.da]:
    'https://cdn.tink.se/legal/terms-and-conditions/da_DK/terms-and-conditions-da_DK-210608.html',
};

export const termsAndConditionFraudPrevention: Pick<
  LanguageCodeUrlMap,
  LanguageCode.en | LanguageCode.de
> = {
  [LanguageCode.en]:
    'https://cdn.tink.se/legal/terms-and-conditions/fraud-prevention-terms-and-conditions-en_US-210331.html',
  [LanguageCode.de]:
    'https://cdn.tink.se/legal/terms-and-conditions/de_DE/fraud-prevention-terms-and-conditions-de_DE-220117.html',
};

export const TermsAndConditions = ({
  match,
  history,
  location: { search },
}: RouteComponentProps<{
  lang: LanguageCode;
}>) => {
  const { lang } = match.params;
  const termsAndConditionsUrl = termsAndConditionsHTML[lang];

  const chromeless = isChromeless(search);

  const onBack = useCallback(() => {
    history.goBack();
  }, [history]);

  if (!lang || !LanguageCode[lang]) {
    return <Redirect to="/terms-and-conditions/en" />;
  }

  return (
    <LegalTemplate onBack={onBack} documentUrl={termsAndConditionsUrl} chromeless={chromeless} />
  );
};
